import { ACCESS_ROUTE } from 'app/access/access-routing.constant';
import { AccountSettingsDataService } from 'app/shared/services/account-settings-data-service';
import { ActivatedRoute } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { EMPTY } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoginService } from 'app/core/authentication/services/login.service';

import { VerifyEmailParams } from 'app/shared/enums/verify-email-params.enum';
import { TranslationService } from 'app/core/internationalization/translation.service';

@Component({
    selector: 'kh-verify-email',
    styleUrls: ['./verify-email.component.less'],
    templateUrl: './verify-email.component.html',
    standalone: false
})
export class VerifyEmailComponent implements OnInit {

  public errorMessage = '';
  public loginRoute = ACCESS_ROUTE.route();

  public constructor(
    private readonly accountSettingsDataService: AccountSettingsDataService,
    private readonly _translationService: TranslationService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly loginService: LoginService) { }

  public ngOnInit(): void {
    this._translationService.instant('VERIFY_EMAIL.INVALID_EMAIL_VERIFICATION_CODE');
    this._translationService.instant('VERIFY_EMAIL.THIS_EMAIL_HAS_ALREADY_BEEN');

    const code = this.activatedRoute.snapshot.paramMap.get(VerifyEmailParams.Code);

    if (code) {
      this.accountSettingsDataService.verifyEmail(code)
        .pipe(
          tap(res => {
            this.loginService.setTokenResponse(res);
            this.loginService.redirectOnSuccess(); }),
          catchError( (res:HttpErrorResponse) => {
            this.errorMessage = this._translationService.instant(res.error.Errors[0]);

            return EMPTY;
          })
        )
        .subscribe();
    }


  }
}
